/** CoStar.Api.Ccms.Text.Models.FieldType */
export var FieldType;
(function (FieldType) {
    FieldType[FieldType["Context"] = 0] = "Context";
    FieldType[FieldType["Analytic"] = 2] = "Analytic";
})(FieldType || (FieldType = {}));
/** CoStar.Api.Ccms.Text.Models.TranslationType */
export var TranslationType;
(function (TranslationType) {
    TranslationType[TranslationType["None"] = 0] = "None";
    TranslationType[TranslationType["AutoTranslated"] = 1] = "AutoTranslated";
    TranslationType[TranslationType["Curated"] = 2] = "Curated";
})(TranslationType || (TranslationType = {}));
/** CoStar.Api.Ccms.Text.Models.TextType */
export var TextType;
(function (TextType) {
    TextType[TextType["EconomicTrends"] = 0] = "EconomicTrends";
    TextType[TextType["Summary"] = 1] = "Summary";
    TextType[TextType["FundamentalsOverview"] = 2] = "FundamentalsOverview";
    TextType[TextType["InvestmentTrends"] = 3] = "InvestmentTrends";
    TextType[TextType["DemandTrends"] = 4] = "DemandTrends";
    TextType[TextType["OccupancySummary"] = 5] = "OccupancySummary";
    TextType[TextType["PerformanceTrends"] = 6] = "PerformanceTrends";
    TextType[TextType["RentTrends"] = 7] = "RentTrends";
    TextType[TextType["SupplyTrends"] = 8] = "SupplyTrends";
    TextType[TextType["University"] = 9] = "University";
    TextType[TextType["StudentProfile"] = 10] = "StudentProfile";
})(TextType || (TextType = {}));
